<div [loading]="loading()">
	@if(stats()){
		<div class="stats shadow mb-4">
		  <div class="stat element-show" [style.--i]="1">
		    <div class="stat-figure text-primary">
			  <i class="stat-icon fa-regular fa-cards-blank"></i>
		    </div>
		    <div class="stat-title text-primary">Cartes</div>
		    <div class="stat-value">{{stats().cards | number:'1.0-0':'fr-FR'}}</div>
		  </div>

		  <div class="stat element-show" [style.--i]="2">
		    <div class="stat-figure text-primary">
			  <i class="stat-icon fa-regular fa-clone"></i>
		    </div>
		    <div class="stat-title text-primary">Unique</div>
		    <div class="stat-value">{{stats().unique | number:'1.0-0':'fr-FR'}}</div>
		  </div>

		  <div class="stat element-show" [style.--i]="3">
		    <div class="stat-figure text-primary">
			  <i class="stat-icon fa-regular fa-euro-sign"></i>
		    </div>
		    <div class="stat-title text-primary">Valeur</div>
		    <div class="stat-value">{{stats().value | number:'1.0-2':'fr-FR'}}</div>
		  </div>
		</div>

		@if(stats().cards>0){
			<!-- tx de completion -->
			<div class="complete-container">
				<lgb-radial-progress [tx]="tx()"></lgb-radial-progress>
				<p class="opacity-60">
					Collection complétée
				</p>
			</div>

			<!-- top 5 des valeur -->
			<ul class="list bg-base-100 rounded-box shadow-md my-4">
			  <li class="p-4 pb-2 text-xs opacity-60 tracking-wide">Top cartes par valeur</li>
			  @for(card of topCard() | slice:0:((open())? 10 : 5); track card.ident){
				<li class="list-row element-show" [style.--i]="$index">
				    <div class="text-4xl font-thin opacity-30 tabular-nums">
				    	{{$index+1}}
				    </div>
				    <div class="card-img">
				    	<img class="size-10" [src]="binderS.getImgCard(card)"/>
				    </div>
				    <div class="list-col-grow">
				      <div>{{getCardName(card)}}</div>
				      <div class="text-xs capitalize font-semibold opacity-60">{{getSetName(card.card)}}</div>
				    </div>
				    <div class="card-price">
				    	{{card.amount | number:'1.0-2':'fr-FR'}}€
				    </div>
				    <div class="card-action">
					    <a href="#" [routerLink]="router.parse('collect-card', [card.ident])" [queryParams]="{backTo: router.parse('stat-overview', [type()])}" class="btn btn-square btn-ghost text-primary">
							<i class="fa-light fa-eyes"></i>
					    </a>
					</div>
				</li>
			  }
			</ul>
			@if(!open()){
				<div class="more-card mb-4">
					<button (click)="open.set(true)" class="text-xs btn text-primary">
						<i class="fa-solid fa-plus"></i> Voir plus de cartes
					</button>
				</div>
			}
			@if(open()){
				<div class="more-card mb-4">
					<button (click)="open.set(false)" class="text-xs btn text-primary">
						<i class="fa-solid fa-minus"></i> Voir moins de cartes
					</button>
				</div>
			}

			<!-- liste des raretés -->
			<div class="mt-4">
				<p class="mb-1">Nombre de cartes par rareté</p>
				<div class="item-container">
					@for(rarity of rarityStats(); track rarity.name){
						<div class="card bg-base-100 shadow-sm mb-2">
							<div class="text-xs header-item">
								<span>{{rarity.name}}</span>
								<span>{{rarity.nb | number:'1.0-0':'fr-FR'}}</span>
							</div>
					      	<progress class="progress progress-primary progress-gradient mt-1" [value]="txCollect(rarity.nb)" max="100"></progress>
						</div>
					}
				</div>
			</div>

			<!-- liste des variantes -->
			<div class="mt-4">
				<p class="mb-1">Nombre de cartes par variante</p>
				<div class="item-container">
					@for(variante of varianteStats(); track variante.name){
						<div class="card bg-base-100 shadow-sm mb-2">
							<div class="text-xs header-item">
								<span class="capitalize">{{variante.name ?? 'Normal'}}</span>
								<span>{{variante.nb | number:'1.0-0':'fr-FR'}}</span>
							</div>
					      	<progress class="progress progress-primary progress-gradient mt-1" [value]="txCollect(variante.nb)" max="100"></progress>
						</div>
					}
				</div>
			</div>

			<!-- liste des condition -->
			<div class="mt-4">
				<p class="mb-1">Nombre de cartes par condition</p>
				<div class="item-container">
					@for(condition of conditionStats(); track condition.name){
						<div class="card bg-base-100 shadow-sm mb-2">
							<div class="text-xs header-item">
								<span>{{condition.name}}</span>
								<span>{{condition.nb | number:'1.0-0':'fr-FR'}}</span>
							</div>
					      	<progress class="progress progress-primary progress-gradient violet mt-1" [value]="txCollect(condition.nb)" max="100"></progress>
						</div>
					}
				</div>
			</div>
		}
		@else{
			<img src="img/skin/empty-card.svg"/>
			<div class="empty-container">
				<p class="subtitle mb-4">
					Aucune donnée disponible pour le moment.<br/>
					Ajoute des cartes à ta collection pour afficher les statistiques
				</p>
				<a [routerLink]="router.get('collect-open-start')" class="btn btn-primary btn-gradient">Ajouter un binder</a>
			</div>
		}
	}
</div>